// extracted by mini-css-extract-plugin
export default {"percent":"ExerciseStudents_percent__YlJZz"};